import { render } from "./mobileCurriculum.vue?vue&type=template&id=784e1cf8"
import script from "./mobileCurriculum.vue?vue&type=script&lang=js"
export * from "./mobileCurriculum.vue?vue&type=script&lang=js"

import "./mobileCurriculum.vue?vue&type=style&index=0&id=784e1cf8&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__